<section>
    <mat-card class="mat-elevation-z2 mat-card">
        <p>
            Please wait while we log you in...
        </p>
        <mat-progress-bar mode="buffer" color="primary"></mat-progress-bar>
        <br />
    </mat-card>
</section>